export default function () {
    return {
        subscriptions: [],
        options: [],
    }
}